module.exports = __webpack_public_path__ + "static/media/BG_PDJ_EventOrganizing.a65f07b6.jpg";